import { useState } from 'react';
import {
  ACCEPTED_FILE_TYPES,
  ShippingDocumentsTypes,
} from 'src/entities/Order';
import { clickElement } from 'src/services/utils';

const DeliveredFile = ({
  deliveredDocument,
  orderNumber,
  uploadDocument,
  canEditDeliveredData,
}) => {
  const [deliveredDocumentState, setDeliveredDocumentState] =
    useState(deliveredDocument);
  const [loading, setLoading] = useState(false);

  const fileUpload = async e => {
    setLoading(true);

    const file = e.target.files[0];

    if (!file) {
      return;
    }

    await uploadDocument({
      file: e.target.files[0],
      documentType: ShippingDocumentsTypes.DELIVERY_RECEIPT,
    })
      .then(file => {
        setDeliveredDocumentState(file);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const buttonText = deliveredDocumentState
    ? 'Alterar comprovante de entrega'
    : 'Adicionar comprovante de entrega';

  const disabledButton = !canEditDeliveredData || loading;

  return (
    <div className="row d-flex align-items-center justify-content-center">
      <div>
        <button
          className={`input-add w-100 ${disabledButton ? 'disabled' : ''}`}
          type="button"
          onClick={() => clickElement('#deliveredFileInput')}
          disabled={disabledButton}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm" role="status" />
          ) : (
            buttonText
          )}
        </button>
        <input
          className="d-none"
          name="deliveredFileInput"
          id="deliveredFileInput"
          type="file"
          placeholder="Clique para adicionar o comprovante de entrega"
          accept={ACCEPTED_FILE_TYPES}
          onChange={fileUpload}
        />
      </div>
      {deliveredDocumentState && (
        <a
          target="_blank"
          rel="noreferrer"
          className="my-3 text-nowrap text-align-center input-files-name"
          href={deliveredDocumentState.documentURL}
        >
          <i className="fas fa-check mr-1" aria-hidden="true" />
          {deliveredDocumentState.name
            ? deliveredDocumentState.name
            : `DeliveryReceipt#${orderNumber}`}
        </a>
      )}
    </div>
  );
};

export default DeliveredFile;
